import React, { Fragment } from 'react';
import PrintComponent from './Print';
import { Breadcrumbs } from '../../../../AbstractElements';
import { useLocation } from 'react-router';

const InvoiceContain = () => {

  const location = useLocation()
  const {rowData, data} =  location.state || {}
  return (
    <Fragment>
      <Breadcrumbs parent='Dashboard' title='Invoice' mainTitle='Invoice' />
      <PrintComponent rowData={rowData} data={data} />
    </Fragment>
  );
};
export default InvoiceContain;
